import { render, staticRenderFns } from "./enviar.vue?vue&type=template&id=b911e304&scoped=true&"
import script from "./enviar.vue?vue&type=script&lang=js&"
export * from "./enviar.vue?vue&type=script&lang=js&"
import style0 from "./enviar.vue?vue&type=style&index=0&id=b911e304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b911e304",
  null
  
)

export default component.exports